const accessRoute = {
  PROFILE: {
    path: "/admin/profile",
  },
};
export default accessRoute;
